import { render, staticRenderFns } from "./ChallengeFactory.vue?vue&type=template&id=9bf7eab4"
import script from "./ChallengeFactory.vue?vue&type=script&lang=js"
export * from "./ChallengeFactory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports